export type KeywordMatchMode = 'own-segment' | 'trailing'

export interface VoiceSendConfig {
  keyword: {
    enabled: boolean
    phrases: string[]
    matchMode: KeywordMatchMode
  }
  autoSend: {
    enabled: boolean
    silenceMs: number
  }
  minWordsToSend: number
}

export const VOICE_SEND_KEYWORD_ENABLED = true
export const VOICE_SEND_KEYWORDS: string[] = ['go']
export const VOICE_SEND_MATCH_MODE: KeywordMatchMode = 'own-segment'
export const VOICE_AUTOSEND_ENABLED = true
export const VOICE_AUTOSEND_SILENCE_MS = 2000
export const VOICE_MIN_WORDS_TO_SEND = 2

export const DEFAULT_VOICE_SEND_CONFIG: VoiceSendConfig = {
  keyword: {
    enabled: VOICE_SEND_KEYWORD_ENABLED,
    phrases: VOICE_SEND_KEYWORDS,
    matchMode: VOICE_SEND_MATCH_MODE,
  },
  autoSend: {
    enabled: VOICE_AUTOSEND_ENABLED,
    silenceMs: VOICE_AUTOSEND_SILENCE_MS,
  },
  minWordsToSend: VOICE_MIN_WORDS_TO_SEND,
}

export function normalizeSpeech(text: string): string {
  return text
    .toLowerCase()
    .replace(/[.,!?;:]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export function wordCount(text: string): number {
  return text.trim().split(/\s+/).filter(Boolean).length
}

export function matchesKeywordSegment(segment: string, phrases: string[]): boolean {
  const norm = normalizeSpeech(segment)
  return phrases.includes(norm)
}

export function stripTrailingKeyword(segment: string, phrases: string[]): string | null {
  const words = normalizeSpeech(segment).split(' ').filter(Boolean)
  const originalWords = segment.trim().split(/\s+/)
  for (const phrase of phrases) {
    const phraseWords = phrase.split(' ').filter(Boolean)
    if (phraseWords.length === 0 || phraseWords.length > words.length) continue
    const tail = words.slice(-phraseWords.length).join(' ')
    if (tail === phrase) {
      return originalWords.slice(0, originalWords.length - phraseWords.length).join(' ')
    }
  }
  return null
}
